__webpack_require__.p = "/cld-product-gallery-widget-react/";